import { render, staticRenderFns } from "./help7_1.vue?vue&type=template&id=b4cf1244&"
import script from "./help7_1.vue?vue&type=script&lang=js&"
export * from "./help7_1.vue?vue&type=script&lang=js&"
import style0 from "./help7_1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports